import { type InputValue } from '~/shared/types'

export function fCurrency(inputValue: InputValue) {
  if (inputValue === null || inputValue === undefined) return ''

  const value = typeof inputValue === 'number' ? inputValue : Number(inputValue)
  if (isNaN(value)) return ''

  const formattedValue = new Intl.NumberFormat('ko-KR').format(value)

  return `${formattedValue}원`
}
